module.exports = __webpack_public_path__ + "media/images/common/lp/icon-pen-c22605dd714aedb35ff350e51ceecb6f.png";